import { combineReducers } from 'redux';
import authReducer from '~reducers/pms-reducers/auth';
import propertyListReducer from '~reducers/pms-reducers/properties/property-list';
import commissionReducer from '~reducers/pms-reducers/properties/commission';
import depositReducer from '~reducers/pms-reducers/properties/deposit';
import accountReducer from '~reducers/pms-reducers/account/account';
import pendingApprovalReducer from '~reducers/pms-reducers/pending-approval';
import listingManagementReducer from '~reducers/pms-reducers/properties/listing-management';
import recordReducer from '~reducers/pms-reducers/properties/record';
import propertyTermsReducer from '~reducers/pms-reducers/properties/terms';

const reducer = combineReducers({
  auth: authReducer,
  dashboard: combineReducers({
    propertyList: propertyListReducer,
    account: accountReducer,
    commissionReducer,
    depositReducer,
    pendingApproval: pendingApprovalReducer,
    listingManagement: listingManagementReducer,
    recordReducer,
    propertyTerms: propertyTermsReducer,
  }),
});

export default reducer;
